import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login");
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        await exchangeGoogleSession(sessionId);
        // Clear the hash and go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login?error=google", { replace: true });
      }
    })();
  }, [nav, exchangeGoogleSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[var(--brand)] border-t-transparent rounded-full animate-spin mx-auto" />
        <div className="overline mt-4 text-[var(--ink-soft)]">Onboarding your AI employee…</div>
      </div>
    </div>
  );
}
